import React from 'react';

const InfoIcon = () => (
  <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.50004 18.9837C4.44554 18.9837 0.333374 14.8725 0.333374 9.81706C0.333374 4.76347 4.44554 0.650391 9.50004 0.650391C14.5545 0.650391 18.6667 4.76256 18.6667 9.81706C18.6667 14.8725 14.5545 18.9837 9.50004 18.9837ZM9.50004 2.48372C5.45662 2.48372 2.16671 5.77364 2.16671 9.81706C2.16671 13.8605 5.45662 17.1504 9.50004 17.1504C13.5435 17.1504 16.8334 13.8605 16.8334 9.81706C16.8334 5.77364 13.5435 2.48372 9.50004 2.48372Z"
      fill="#959595"
    />
    <path
      d="M10.4167 12.5677V8.90104C10.4167 8.39504 10.0069 7.98438 9.5 7.98438H7.66667V9.81771H8.58333V12.5677H6.75V14.401H12.25V12.5677H10.4167Z"
      fill="#959595"
    />
    <path
      d="M9.50008 7.29557C10.1329 7.29557 10.6459 6.78257 10.6459 6.14974C10.6459 5.51691 10.1329 5.00391 9.50008 5.00391C8.86726 5.00391 8.35425 5.51691 8.35425 6.14974C8.35425 6.78257 8.86726 7.29557 9.50008 7.29557Z"
      fill="#959595"
    />
  </svg>
);

export default InfoIcon;
